"use client";

import LanguageSwitch from "./Language";
import LoginDialog from "./Login";
import ThemeSwitcher from "./ThemeSwitcher";
import SpaLink from "./SpaLink";
import { Calculator } from "lucide-react";
import { Button } from "@/components/ui/button";
import { usePublicInfo } from "@/contexts/PublicInfoContext";
import { useTheme } from "@/contexts/ThemeContext";
import { useTranslation } from "react-i18next";
import { dispatchOpenRemainingValueCalculatorEvent } from "@/lib/remainingValueEvents";
import { BRAND_TITLE } from "@/lib/brand";

const NavBar = () => {
  const { publicInfo } = usePublicInfo();
  const { guestDisplay } = useTheme();
  const { t } = useTranslation();

  return (
    <nav className="dida-nav sticky top-0 z-50 w-full border-b border-pink-200/60 bg-background/75 backdrop-blur-xl supports-[backdrop-filter]:bg-background/55 transition-all duration-300">
      <div className="container mx-auto flex h-14 md:h-16 items-center justify-between px-4">
        <div className="flex items-center gap-2">
          <SpaLink href="/" className="flex items-center gap-2.5 hover:opacity-85 transition-all">
            <div className="dida-mark h-8 w-8 rounded-full flex items-center justify-center shadow-md shadow-pink-300/40">
              <span className="text-white font-bold text-base">滴</span>
            </div>
            <span className="dida-title text-lg md:text-xl font-bold tracking-wide">
              {BRAND_TITLE}
            </span>
          </SpaLink>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-2">
          <ThemeSwitcher />
          {guestDisplay.showPrice && guestDisplay.showExpiredAt && (
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="h-9 w-9"
              onClick={dispatchOpenRemainingValueCalculatorEvent}
            >
              <Calculator className="h-4 w-4" />
              <span className="sr-only">
                {t("remainingValue.title", { defaultValue: "Remaining Value Calculator" })}
              </span>
            </Button>
          )}
          <LanguageSwitch />

          {publicInfo?.private_site ? (
            <LoginDialog
              autoOpen={publicInfo?.private_site}
              info={t('common.private_site')}
              onLoginSuccess={() => { window.location.reload(); }}
            />
          ) : (
            <LoginDialog />
          )}
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
